import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import Hero from "../components/Hero";
import About from "../components/About";
import Skills from "../components/Skills";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    console.log("Location State:", location.state);
    if (location.state?.scrollTo) {
      // Use a timeout to ensure the page is fully rendered before scrolling
      const timer = setTimeout(() => {
        scroller.scrollTo(location.state.scrollTo, {
          duration: 500,
        });
      }, 100); // Adjust the delay if needed

      // Clear the timeout to avoid memory leaks
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div>
      <Hero />
      <About />
      <Skills />
      <Services />
      <Portfolio />
      <Contact />
    </div>
  );
};

export default Home;
